import { useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

export function useClientNotificationLookup(subscriptionId = null) {
    const queryClient = useQueryClient()

    return useQuery({
        queryKey: ['notification-email', subscriptionId],
        queryFn: async ({ signal }) => {
            if (!subscriptionId) {
                return [];
            }

            const url = `${process.env.REACT_APP_API_URL}/notification-email?subscriptionId=${subscriptionId}`;

            try {
                const response = await axios({
                    url,
                    method: 'GET',
                    withCredentials: true,
                    signal,
                    timeout: 10000,
                });

                const notifications = response?.data?.data ?? [];
                const transformedData = notifications.map((q) => ({
                    id: q.id,
                    email: q.email,
                    name: q.name,
                    type: q.type,
                    sent: q.sent,
                    message: q.message,
                    createdAt: q.createdAt
                }));

                return transformedData;

            } catch (error) {
                if (signal.aborted || error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
                    const cachedData = queryClient.getQueryData(['notification-email', subscriptionId]);
                    return cachedData || [];
                }

                if (error?.response?.status === 401) {
                    queryClient.invalidateQueries({
                        queryKey: ['session-lookup'],
                    });
                }

                throw error?.response?.data ?? error;
            }
        },
        enabled: !!subscriptionId,
        staleTime: 2 * 60 * 1000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: (failureCount, error) => {
            if (error?.name === 'CanceledError' ||
                error?.code === 'ERR_CANCELED' ||
                (error?.response?.status >= 400 && error?.response?.status < 500)) {
                return false;
            }
            return failureCount < 2;
        },
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
        structuralSharing: false,
    })
}